import { useMemo } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import ExamPlay from "@/exam/pages/ExamPlay"
import { ExamProvider } from "@/exam/context"
import { createLearnerProvider } from "@/exam/provider"

export default function LearnerExamPlay() {
  const { runId } = useParams()
  const [sp] = useSearchParams()
  const courseId = sp.get("course_id") || undefined
  const testId = sp.get("test_id") || undefined
  const nav = useNavigate()
  const provider = useMemo(() => createLearnerProvider({ orgId: undefined, runId, courseId, testId }), [runId, courseId, testId])
  return (
    <ExamProvider provider={provider}>
      <ExamPlay
        onResult={({ submissionId, score, full, runId: rid, spend }) => {
          const qs = new URLSearchParams({ score: String(score), full: String(full), spend: String(spend) })
          nav(`/learn/exam/result/${rid || runId}?${qs.toString()}`)
        }}
      />
    </ExamProvider>
  )
}
